// extracted by mini-css-extract-plugin
export var notificationHost = "_hy-0";